import React from "react";
import "./DecisionOptions.css";

const DecisionOptions = ({
  options,
  selectedOption,
  onOptionSelect,
  language,
}) => {
  const getOptionStyle = (option) => {
    if (selectedOption === option) {
      return "decision-option selected";
    }
    return "decision-option";
  };

  const getOptionIcon = (option) => {
    if (selectedOption === option) {
      return "✓";
    }
    return "○";
  };

  const getOptionColor = (option) => {
    if (selectedOption === option) {
      if (option === "Adopt as-is" || option === "完全采纳") {
        return "adopt";
      } else if (option === "Revise" || option === "修正") {
        return "revise";
      } else if (option === "Override" || option === "完全覆写") {
        return "override";
      }
    }
    return "default";
  };

  return (
    <div className="decision-options">
      <h4 className="options-title">
        {language === "zh"
          ? "请选择您的决策："
          : "Please select your decision:"}
      </h4>
      <div className="options-container">
        {options.map((option, index) => (
          <button
            key={index}
            className={`${getOptionStyle(option)} ${getOptionColor(option)}`}
            onClick={() => onOptionSelect(option)}
          >
            <span className="option-icon">{getOptionIcon(option)}</span>
            <span className="option-text">{option}</span>
          </button>
        ))}
      </div>

      {selectedOption && (
        <div className="selected-decision">
          <p className="selected-text">
            {language === "zh" ? "您已选择：" : "You have selected:"}
            <strong> {selectedOption}</strong>
          </p>
        </div>
      )}
    </div>
  );
};

export default DecisionOptions;
